import { EpgChannel } from 'store/epg/actions.types';
import { EpgRequestedBy } from 'store/epg/reducer';
import { EpgProgram, RBChannel } from 'store/railsBuilder/reducer.types';
import { CatchRequestError } from 'store/user/reducer.types';
import { RequestStatus } from 'store/utils';

export enum EpgLayout {
    GRID = 'grid',
    LIST = 'list',
}

export type EpgState = {
    epg: {
        status: RequestStatus;
        start: number; // timestamp in seconds
        end: number; // timestamp in seconds
        error?: CatchRequestError;
        data: Record<string, Record<EpgChannel['channelId'], EpgProgram[]>>;
        requestedBy: EpgRequestedBy;
        newDayIsLoading: boolean;
    };
    fullscreen: boolean;
    subtitlesDialogVisible: boolean;
    focusToNow: boolean;
    epgLastUpdated?: number;
    epgSelectedLayout?: EpgLayout;
    previouslyWatchedChannelByProfile: {
        [profileId: string]: RBChannel['editorial']['id'];
    };
};
